import { clsxMerge } from "shared/lib/helpers";
import { Avatar } from "shared/ui";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";

import { ReviewItemI } from "./interfaces";
import { UTMLink } from "@/components/base/utm-link";

type ReviewItemPropsI = ReviewItemI & PropsWithClassNameI;

export const ReviewItem = ({
  className,
  body,
  logoURL,
  logoClassName,
  authorName,
  authorTitle,
  authorAvatarURL,
  readMoreURL,
  reverseLayout,
}: ReviewItemPropsI) => (
  <div className={clsxMerge("", className)}>
    {logoURL && (
      <div className={clsxMerge("flex", reverseLayout && "justify-end")}>
        <div className="mb-8 flex items-center rounded bg-[rgba(0,0,0,.08)] p-2">
          <img
            className={clsxMerge("h-[24px]", logoClassName)}
            src={logoURL}
            alt="Company logo"
          />
        </div>
      </div>
    )}

    <p
      className={clsxMerge(
        "mb-8 whitespace-pre-line typography-body-2 sm:typography-body-1"
      )}
    >
      {body}
    </p>

    <div className={clsxMerge("flex flex-col", reverseLayout && "items-end")}>
      <div className="flex items-center gap-4">
        <Avatar
          className="h-10 w-10"
          src={authorAvatarURL || ""}
          placeholderText={authorName}
        />

        <span>
          <h3 className="typography-body-2">{authorName}</h3>
          <p className="typography-body-3">{authorTitle}</p>
        </span>
      </div>

      {readMoreURL && (
        <UTMLink
          className="btn-ae-default btn btn-sm mt-8 w-[162px] rounded-md"
          href={readMoreURL}
        >
          Read more
        </UTMLink>
      )}
    </div>
  </div>
);
